import { useContext } from 'react';
import { AppContext, usePermission } from '@ctsu/loader';
import { useSelector } from 'react-redux';

export const CanUserHasGroup = () => {
  const leadGrp = useSelector(state => state.prtDetails.prtInfo.leadGrp);
  const context = useContext(AppContext);
  const { userGroups } = context && context.session;
  return userGroups && (userGroups.includes('CTSU') || userGroups.includes(leadGrp));
};

export const CanUserViewSection = (per) => (usePermission(per));

// Protocol Details,Contact, Status and Completion Dates
export const CanUserAccessInfo = () => (usePermission('protocol.info'));
export const CanUserViewContact = () => (usePermission('protocol.contact'));
export const CanUserEditContact = () => (usePermission('protocol.contact.edit')
&& CanUserHasGroup());
export const CanUserViewStatusChange = () => (usePermission('protocol.status'));
export const CanUserEditStatusChange = () => (usePermission('protocol.status.edit')
     && CanUserHasGroup());
export const CanUserViewPCDDates = () => (usePermission('protocol.status'));
export const CanUserEditPCDDates = () => (usePermission('protocol.status.edit')
     && CanUserHasGroup());
export const CanUserEditIternalComments = () => (usePermission('protocol.internal.comments')
     && CanUserHasGroup());
export const CanUserViewSync = () => (usePermission('protocol.sync'));

// Participation
export const CanUserViewCountries = () => (usePermission('protocol.participation.country'));
export const CanUserEditCountries = () => (usePermission('protocol.participation.country.edit')
&& CanUserHasGroup());
export const CanUserDelCountries = () => (usePermission('protocol.participation.country.delete')
 && CanUserHasGroup());

export const CanUserViewParticipation = () => (usePermission('protocol.participation'));
export const CanUserEditParticipation = () => (usePermission('protocol.participation.participant.edit')
&& CanUserHasGroup());
export const CanUserEditRestrictions = () => (usePermission('protocol.participation.restriction.edit')
 && CanUserHasGroup());

// Versions
export const CanUserAccessVersions = () => (usePermission('protocol.versions'));
export const CanUserAccessPIOVersions = () => (usePermission('protocol.versions.pio'));
export const CanUserEditLocalVersions = () => (usePermission('protocol.versions.edit')
 && CanUserHasGroup());
export const CanUserDeleteLocalVersions = () => (usePermission('protocol.versions.delete')
&& CanUserHasGroup());

// Study Agents
export const CanUserAccessAgents = () => (usePermission('protocol.agents'));
export const CanUserAccessAgentsCtep = () => (usePermission('protocol.agents.ctep'));
export const CanUserDeleteAgentsCtep = () => (usePermission('protocol.agents.ctep.delete')
&& CanUserHasGroup());
export const CanUserEditAgentsCtep = () => (usePermission('protocol.agents.ctep.edit')
&& CanUserHasGroup());
export const CanUserAccessAgentsDevice = () => (usePermission('protocol.agents.device'));
export const CanUserDeleteAgentsDevice = () => (usePermission('protocol.agents.device.delete') && CanUserHasGroup());
export const CanUserEditAgentsDevice = () => (usePermission('protocol.agents.device.edit')
 && CanUserHasGroup());
export const CanUserEditAgentsIND = () => (usePermission('protocol.agents.ind.edit')
 && CanUserHasGroup());
export const CanUserAccessAgentsNonCtep = () => (usePermission('protocol.agents.nonctep'));
export const CanUserDeleteAgentsNonCtep = () => (usePermission('protocol.agents.nonctep.delete') && CanUserHasGroup());
export const CanUserAccessAgentsTreatment = () => (usePermission('protocol.agents.treatment'));

// PSR
export const CanUserAccessPSR = () => (usePermission('protocol.psr'));
export const CanUserViewPSRConfig = () => (usePermission('protocol.psr.config'));
export const CanUserViewPSRAffiliations = () => (usePermission('protocol.psr.affiliations'));
export const CanUserEditPSRAffiliations = () => (usePermission('protocol.psr.affiliations.edit')
&& CanUserHasGroup());
export const CanUserDelPSRAffiliations = () => (usePermission('protocol.psr.affiliations.delete')
&& CanUserHasGroup());
export const CanUserViewPSRDetails = () => (usePermission('protocol.psr.details'));
export const CanUserEditPSRDetails = () => (usePermission('protocol.psr.details.edit')
&& CanUserHasGroup());

// CIRB
export const CanUserAccessCirb = () => (usePermission('protocol.cirb'));
export const CanUserAccessCirbDocs = () => (usePermission('protocol.cirb.docs'));
export const CanUserAccessCirbEvents = () => (usePermission('protocol.cirb.events'));
export const CanUserAccessCirbParticipation = () => (usePermission('protocol.cirb.participation'));
export const CanUserAccessCirbApproval = () => (usePermission('protocol.cirb.approval'));

// OPEN Setup
export const CanUserAccessOPENSetup = () => (usePermission('protocol.open.setup'));
export const CanUserViewOPENSetupConfig = () => (usePermission('protocol.open.setup.config'));
export const CanUserEditOPENSetupConfig = () => (usePermission('protocol.open.setup.config.edit')
&& CanUserHasGroup());
export const CanUserEditMisc = () => (usePermission('protocol.open.misc.edit')
&& CanUserHasGroup());

export const CanUserViewOPENSteps = () => (usePermission('protocol.open.steps'));
export const CanUserEditOPENSteps = () => (usePermission('protocol.open.steps.edit')
&& CanUserHasGroup());
export const CanUserDelOPENSteps = () => (usePermission('protocol.open.steps.delete')
&& CanUserHasGroup());


export const CanUserViewOPENProvider = () => (usePermission('protocol.open.provider'));
export const CanUserEditOPENProvider = () => (usePermission('protocol.open.provider.edit')
&& CanUserHasGroup());

export const CanUserViewOPENRelations = () => (usePermission('protocol.open.relations'));
export const CanUserEditOPENRelations = () => (usePermission('protocol.open.relations.edit')
&& CanUserHasGroup());

export const CanUserViewOPENPerson = () => (usePermission('protocol.open.person'));
export const CanUserEditOPENPerson = () => (usePermission('protocol.open.person.edit')
&& CanUserHasGroup());
export const CanUserDelOPENPerson = () => (usePermission('protocol.open.person.delete')
&& CanUserHasGroup());

// Integrations
export const CanUserAccessIntegrations = () => (usePermission('protocol.integrations'));
export const CanUserAccessIntegrationCM = () => (usePermission('protocol.integrations.cm'));
export const CanUserEditIntegrationCM = () => (usePermission('protocol.integrations.cm.edit')
 && CanUserHasGroup());
export const CanUserEditIntegration = () => (usePermission('protocol.integrations.edit')
&& CanUserHasGroup());
export const CanUserAccessIntegrationTask = () => (usePermission('protocol.integrations.task'));
export const CanUserAccessIntegrationStart = () => (usePermission('protocol.integrations.start'));


// Funding
export const CanUserAccessFunding = () => (usePermission('protocol.funding.percase'));
export const CanUserEditAccessFunding = () => (usePermission('protocol.funding.percase.edit')
&& CanUserHasGroup());
export const CanUserViewFundingDetails = () => (usePermission('protocol.funding.details'));
export const CanUserEditFundingDetails = () => (usePermission('protocol.funding.details.edit')
&& CanUserHasGroup());

// Match Box
export const CanUserEditMatchBox = () => (usePermission('protocol.matchbox.flag.edit') && CanUserHasGroup());
export const CanUserViewMatchBox = () =>  (usePermission('protocol.matchbox.view') && CanUserHasGroup());
export const CanUserSyncCohorts = () => (usePermission('protocol.matchbox.cohort.sync') && CanUserHasGroup());
export const CanUserEditCohorts = () => (usePermission('protocol.matchbox.cohort.edit') && CanUserHasGroup());
export const CanUserAuditCohorts = () =>  usePermission('protocol.matchbox.cohort.audit');

// Cohort Arm
export const CanUserEditArmCohorts = () => usePermission('protocol.cohorts.arms.edit');
export const CanUserAddArmCohorts = () => usePermission('protocol.cohorts.arms.add');
// Admin Tile
/*
    RSSMOD-906: https://jira.westat.com/browse/RSSMOD-906
    RSSMOD-907: https://jira.westat.com/browse/RSSMOD-907
*/
export const CanUserAccessAdmin = () => (usePermission('protocol.admin'));
export const CanUserStatusProcess = () => (usePermission('protocol.admin.status.process'));
